import { render, staticRenderFns } from "./BaseSidebarNavigation.vue?vue&type=template&id=30f97d3b&"
import script from "./BaseSidebarNavigation.vue?vue&type=script&lang=js&"
export * from "./BaseSidebarNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports